<div class="container">
    <control-shell *ngIf="config.component" [config]="config" [ableMoveUp]="ableMoveUp" [ableMoveDown]="ableMoveDown"
        [ableMoveLeft]="ableMoveLeft" [ableMoveRight]="ableMoveRight" [options]="options" (movedown)="moveDown($event)"
        (moveleft)="moveLeft($event)" (moveright)="moveRight($event)" (moveup)="moveUp($event)"
        (delete)="onDeleteSelf($event)" (click)="onSelectSelf($event)">
    </control-shell>
    <div class="template-row" *ngFor="let row of config.contains;index as i">
        <div class="one-control" *ngFor="let item of row;index as j" [style.width]="item.width+'%'">
            <control-shell *ngIf="item.type!=='section'" [config]="item"
                [ableMoveUp]="ableMoveUp||i!==0||(i===0&&config.contains[i].length!==1)"
                [ableMoveDown]="ableMoveDown||i!==(config.contains.length-1)||(i===(config.contains.length-1)&&config.contains[i].length!==1)"
                [ableMoveLeft]="j!==0" [ableMoveRight]="j!==(row.length-1)" [invalidControlId]="invalidControlId"
                [selectedControl]="selectedControl" [options]="options" (movedown)="moveDownChild($event,i,j)"
                (moveleft)="moveLeftChild($event,i,j)" (moveright)="moveRightChild($event,i,j)"
                (moveup)="moveUpChild($event,i,j)" (delete)="onDeleteChild($event,i,j)"
                (widthchange)="childWidthChange($event,i,j)" (click)="onSelectControl($event,i,j)">
            </control-shell>
            <section-shell *ngIf="item.type==='section'" [config]="item"
                [ableMoveUp]="ableMoveUp||i!==0||(i===0&&config.contains[i].length!==1)"
                [ableMoveDown]="ableMoveDown||i!==(config.contains.length-1)||(i===(config.contains.length-1)&&config.contains[i].length!==1)"
                [ableMoveLeft]="j!==0" [ableMoveRight]="j!==(row.length-1)" [invalidControlId]="invalidControlId"
                [selectedControl]="selectedControl" [options]="options" (movedown)="moveDownChild($event,i,j)"
                (moveleft)="moveLeftChild($event,i,j)" (moveright)="moveRightChild($event,i,j)"
                (moveup)="moveUpChild($event,i,j)" (delete)="onDeleteChild($event,i,j)"
                (selectChange)="onSelectChange($event)" (deleteControl)="onDeleteControl($event)">
            </section-shell>
        </div>
    </div>
</div>